import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientDentalProblem, PatientDentalProblemData } from '../../../interfaces/masters/patient-dental-problem';
import { PatientDentalProblemApi } from '../api/patient-dental-problem.api';

@Injectable()
export class PatientDentalProblemService extends PatientDentalProblemData {

  constructor(private api: PatientDentalProblemApi) { 
    super();   
  }
  list(url: string): Observable<PatientDentalProblem[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PatientDentalProblem>{
      return this.api.getById(url); 
  }

  create(url: string, data:PatientDentalProblem): Observable<PatientDentalProblem> {
    return this.api.add(url,data);
  }

  update(url: string, data:PatientDentalProblem): Observable<PatientDentalProblem> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
